import React, { useEffect, useRef, useState } from 'react';
import { TextField, Select, MenuItem, Avatar, Button, Typography } from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import firebase from 'firebase/app';
import 'firebase/firestore';
export const FormikTextField = ({ field, type, meta, form, ...rest }) => {
  const error = form.errors[field.name];
  const touched = form.touched[field.name];

  return (
    <TextField
      type={type}
      {...field}
      fullWidth
      {...rest}
      helperText={error}
      error={Boolean(error && touched)}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  large: {
    margin: '0 auto',
    marginTop: theme.spacing(1),
    width: 200,
    height: 200,
  },
  root: {
    cursor: 'pointer',
  },
  info: {
    marginTop: theme.spacing(1),
  },
}));

export function FormikImageField({ field, form, style, ...rest }) {
  const ref = useRef();
  const [src, setSrc] = useState('');

  const styles = useStyles();

  useEffect(() => {
    if (typeof field.value === 'object') {
      if (field.value) {
        setSrc(URL.createObjectURL(field.value));
      } else {
        setSrc(null);
      }
    } else if (field.value && !field.value?.includes('http')) {
      firebase
        .storage()
        .ref(field.value)
        .getDownloadURL()
        .then((url) => setSrc(url));
    }
  }, [field, setSrc]);
  return (
    <div className={styles.root} style={style}>
      <input
        type="file"
        hidden
        {...rest}
        onChange={(e) => {
          form.setFieldValue(field.name, e.target.files[0]);
        }}
        ref={ref}
      />
      {src ? (
        <Avatar
          variant="square"
          className={styles.large}
          src={src}
          alt=""
          onClick={() => ref.current.click()}
        />
      ) : (
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={() => ref.current.click()}
          >
            העלאת תמונה
          </Button>
          <Typography
            style={{marginTop: 10}}
            color="textSecondary"
            variant="body1"
          >
            גודל מומלץ:{' '}
            <span style={{ direction: 'rtl' }}>{'300x300'}</span>
          </Typography>
        </>
      )}
    </div>
  );
}
export function FormikFontSelect({
  field,
  meta,
  form,
  availableFonts = [],
  ...rest
}) {
  return (
    <Select
      style={{ fontFamily: field.value, width: '100%' }}
      value={field.value}
      onChange={(e) => {
        form.setFieldValue(field.name, e.target.value);
      }}
    >
      {availableFonts.map((font) => {
        return (
          <MenuItem value={font} key={font} style={{ fontFamily: font }}>
            {font}
          </MenuItem>
        );
      })}
    </Select>
  );
}

export const TimePickerField = ({ field, form, isDisabled, ...other }) => {
  const time = moment(field.value, 'HH:mm');
  return (
    <KeyboardTimePicker
      clearable
      disabled={isDisabled(form)}
      disablePast
      format="HH:mm"
      ampm={false}
      name={field.name}
      value={time}
      // if you are using custom validation schema you probably want to pass `true` as third argument
      onChange={(date) =>
        form.setFieldValue(field.name, date.format('HH:mm'), false)
      }
      {...other}
    />
  );
};
